class NodeHandler {
	constructor (node){
		this.node = node || null;
	}

	setNode (node) {
		this.node = node;
	}

	closestSelector (node , selector) {
		let el = node || this.node;

		if (!el || el.tagName == "BODY") {
			return null;
		}

		if (selector.indexOf("#") === 0) {
			this.closestSelectorWithId
			lookUpSelector = lookUpSelector.replace("#","");
			while (!el.getAttribute("id") ||  ( el.getAttribute("id") && el.getAttribute("id") !== lookUpSelector) ){

				el = el.parentNode;

				if (!el || el.tagName == "BODY") {
					el = null;
					break;
				}
			}

		} else if (lookUpSelector.indexOf("[") === 0 && lookUpSelector.indexOf("]") > -1 && lookUpSelector.lastIndexOf("]") === lookUpSelector.length -1) {

			lookUpSelector = lookUpSelector.replace("[","").replace("]","");
			var attributeValueSelector = "";
			var attributeNameSelector = "";

			if (lookUpSelector.indexOf("=") > -1) {
				attributeNameSelector = lookUpSelector.split("=")[0];
				attributeValueSelector = lookUpSelector.split("=")[1];
			}

			if (attributeValueSelector) {
				while ( !el.getAttribute  || !el.getAttribute(attributeNameSelector) || el.getAttribute(attributeNameSelector) !== attributeValueSelector ) {

					el = el.parentNode;

					if (!el || el.tagName == "BODY") {
						el = null;
						break;
					}
				}
			} else {
				while ( !el.getAttribute  || !el.getAttribute(lookUpSelector) ) {

					el = el.parentNode;

					if (!el || el.tagName == "BODY") {
						el = null;
						break;
					}
				}
			}

		} else {
			lookUpSelector = lookUpSelector.replace(".","");
			while ( !el.classList  || !el.classList.contains || !el.classList.contains(lookUpSelector) ) {

				el = el.parentNode;

				if (!el || el.tagName == "BODY") {
					el = null;
					break;
				}
			}
		}

		return el;
	}
}

function createNodeFromString(htmlString) {
	let div = document.createElement('div');
	div.innerHTML = htmlString.trim();
	// Change this to div.childNodes to support multiple top-level nodes
	return div.firstChild;
}

function getParents(el, parentSelector /* optional */) {

	// If no parentSelector defined will bubble up all the way to *document*
	// if (parentSelector === undefined) {
	// 	parentSelector = document;
	// }

	var parents = [];
	var p = el.parentNode;

	while (p.closest(parentSelector)) {

		var o = p.closest(parentSelector);

		if (!o || o.tagName == "BODY") {
			o = null;
			break;
		}

		parents.push(o);
		p = o.parentNode;


	}

	if (!parents.length) {
		parents = null;
	}
	// parents.push(parentSelector); // Push that parentSelector you wanted to stop at

	return parents;
}

export { createNodeFromString };
export { getParents };
export default NodeHandler

